import APIClient from '@/shared/http/clients/api'

const resourceName = 'tag-card'
const APICore = process.env.APIBaseURLCore

const GetAllPaging = (limit, index, filters = {}, config = {}) => {
  let queryParams = `page=${index}&size=${limit}`

  // Só adiciona os parâmetros se tiverem valores numéricos válidos e maiores que 0
  if (filters.cardId != null && filters.cardId !== '' && filters.cardId !== undefined) {
    const cardIdNum = Number(filters.cardId)
    if (!isNaN(cardIdNum) && cardIdNum > 0) {
      queryParams += `&cardId=${cardIdNum}`
    }
  }
  if (filters.tagId != null && filters.tagId !== '' && filters.tagId !== undefined) {
    const tagIdNum = Number(filters.tagId)
    if (!isNaN(tagIdNum) && tagIdNum > 0) {
      queryParams += `&tagId=${tagIdNum}`
    }
  }

  return APIClient.get(`${APICore}/${resourceName}/?${queryParams}`, config)
}

const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)

const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const TagCardRepository = {
  GetAllPaging,
  Create,
  Delete
}

export default TagCardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/tag-card.js